"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AssociatedDepartments {
}
class MonthAndAnnualObj {
}
